<template>
  <div class="modal fade" id="addProductCostDelivery" data-bs-backdrop="static" role="dialog" style="display: none;" data-bs-keyboard="false">
		<div class="modal-dialog modal-lg">
			<form class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="backDropModalTitle">Modify Product Cost</h5>
					<button type="button" 
						class="btn-close" 
						data-bs-dismiss="modal" 
						aria-label="Close"
						@click="closeModal"
					></button>
				</div>
				<div class="modal-body">
					<!-- General Information -->
					<div class="card mb-3">
						<div class="card-body">
							<div class="row">
								<div class="mb-3 col-md-3 fv-plugins-icon-container">
									<label for="firstName" class="form-label">Issue Date</label>
									<flat-pickr 
										v-model="stateData.issue_date"
										:config="calendarConfig" 
										placeholder="Select a date" 
										name="created-date" 
										class="form-control" disabled>
									</flat-pickr>
								</div>
								<div class="col-md-6 mb-4">
									<label class="form-label me-2">Partner Name</label>
									<span>
										<a class="me-1" 
											data-bs-toggle="collapse" 
											href="#collapseExample" 
											role="button" 
											aria-expanded="true" 
											aria-controls="collapseExample"
										>
										<span style="font-size: small;"><em>(show payment info)</em></span>
									</a>
									</span>
									<VueMultiselect 
										v-model="partnerSelected" 
										:options="list_partners" 
										placeholder="Please choose partner" 
										label="partner_name" 
										:close-on-select="true"
										:clear-on-select="false"
										disabled
									/>
								</div>
								<div class="col-md-3 mb-4">
									<label class="form-label">Partner Code</label>
									<input class="form-control disabled" 
										type="text" 
										v-model="stateData.partner_code"
										disabled
									>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12" v-if="partnerSelected">
									<div class="collapse" id="collapseExample">
										<div class="alert alert-primary" role="alert">
											<span class="alert-heading fw-bold">PAYMENT INFORMATION</span>
											<div class="row mt-3">
												<div class="col-md-3">
													<span v-if="partnerSelected.has_deposit == 1">HAS DEPOSIT</span>
													<span v-else>NO DEPOSIT</span>
												</div>
												<div class="col-md-3" v-if="partnerSelected.has_deposit == 1">
													<span class="me-1">Deposit: {{ partnerSelected.percent_deposit }}</span>
													<span>%</span>
												</div>
												<div class="col-md-3" v-if="partnerSelected.has_deposit == 1">
													<span class="me-1">Balance: {{ partnerSelected.percent_balance }}</span>
													<span>%</span>
												</div>
											</div>
											<div class="row mt-2">
												<div class="col-md-3">
													<span>Payment Method: </span>
													<span>{{ getPaymentName(partnerSelected.payment_method) }}</span>
												</div>
												<div class="col-md-3">
													<span>Term: </span>
													<span class="me-1">{{ partnerSelected.term }}</span>
													<span>days</span>
												</div>
												<div class="col-md-3">
													<span>Closing Time: </span>
													<span>{{ getClosingTime(partnerSelected.closing_time) }}</span>
												</div>
												<div class="col-md-3" v-if="partnerSelected.closing_time == 7">
													<span>On Exact Date: </span>
													<span>{{ partnerSelected.exact_date }}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- / General Information -->

					<!-- Cost Information -->
					<div class="card mb-4">
						<!-- <h5 class="card-header">Main Information</h5> -->
						<!-- <hr class="my-0"> -->
						<div class="card-body">
							<div class="row">
								<div class="col-md-5 mb-4">
									<label for="" class="form-label">Category Product Cost</label>
									<span class="m-1">(*)</span>
									<select class="form-select" v-model="stateData.category_cost" disabled>
										<template v-for="(item, index) in categoryProductCostOptions" :key="index">
											<option :value="item.id">
												{{ item.category_name }}
											</option>
										</template>
									</select>
								</div>
								<div class="col-md-4 mb-4">
									<label for="" class="form-label">Partner Invoice No</label>
									<span class="m-1">(*)</span>
									<input type="text" 
										class="form-control" 
										placeholder="INV_001, INV_002,..."
										v-model="stateData.partner_inv_no"
									>
									<div class="error-msg" v-if="v$.stateData.partner_inv_no.$error"> 
										{{ v$.stateData.partner_inv_no.$errors[0].$message }}
									</div>
								</div>
								<div class="col-md-3 mb-4">
									<label for="" class="form-label">Partner Invoice Date</label>
									<flat-pickr 
										v-model="stateData.partner_inv_date"
										:config="calendarConfig" 
										placeholder="Select a date" 
										class="form-control">
									</flat-pickr>
									<div class="error-msg" v-if="v$.stateData.partner_inv_date.$error"> 
										{{ v$.stateData.partner_inv_date.$errors[0].$message }}
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-3 mb-4">
									<label for="" class="form-label">Payment Due Date</label>
									<flat-pickr 
										v-model="stateData.payment_due_date"
										:config="calendarConfig" 
										class="form-control" disabled>
									</flat-pickr>
								</div>
								<div class="col-md-3 mb-4">
									<label for="" class="form-label">Actual Payment Date</label>
									<flat-pickr 
										v-model="stateData.actual_payment_date"
										:config="calendarConfig" 
										class="form-control">
									</flat-pickr>
									<div class="error-msg" v-if="v$.stateData.actual_payment_date.$error"> 
										{{ v$.stateData.actual_payment_date.$errors[0].$message }}
									</div>
								</div>
								<div class="col-md-3 mb-4">
									<label class="form-label me-2">Actual Amount (VND)</label>
									<span class="cursor-pointer" @click="handleIconPasteCostAmount">
										<span v-tooltip="'Fill Cost Amount (-Tax)'">
											<i class='bx bx-down-arrow-circle fs-4'></i>
										</span>
									</span>
									<cleave class="form-control px-1" 
										style="text-align: right;"
										v-model="stateData.cost_actual_amount"
										:options="cleaveOptions.cost_actual_amount"
									/>
									<div class="error-msg" v-if="v$.stateData.cost_actual_amount.$error"> 
										{{ v$.stateData.cost_actual_amount.$errors[0].$message }}
									</div>
								</div>
								<div class="col-md-3 mb-4">
									<label class="form-label">Status</label>
									<span class="m-1">(*)</span>
									<select 
										class="form-select text-capitalize"
										v-model="stateData.status"
									>
										<template v-for="(item, index) in costStatusOptions" :key="index">
											<option :value="item.id">{{ item.name }}</option>
										</template>
									</select>
								</div>
							</div>
							<div class="row">
								<div class="table-responsive mb-4">
									<table class="table table-bordered table-hover" v-if="stateData.delivery_detail_list">
										<thead class="table-light lmd-light-color">
											<tr>
												<th>Product Cost Name</th>
												<th class="text-center">Cost Amount (-TAX)</th>
												<th class="text-center">Ex. Rate</th>
												<th class="text-center">Tax</th>
											</tr>
										</thead>
										<tbody class="table-border-bottom-0">
											<tr v-for="(detail, index) in listProucts" :key="index">
												<td class="width-40-percent p-2"><span>{{ detail.product_name }}</span></td>
												<td class="width-25-percent text-end p-2">{{ stateData.sell_currency }} {{ formatCurrency(calculateAmount(detail)) }}</td>
												<td class="width-15-percent text-end p-2">{{ formatCurrency(stateData.sell_exchange_rates) }}</td>
												<td class="width-20-percent p-2">
													<span class="me-1">{{ detail.tax_sell_name_1 ? detail.tax_sell_name_1 + ": " + detail.tax_sell_value_1 + "%" : ""}}</span>
													<span class="me-1">{{ detail.tax_sell_name_2 ? ", " + detail.tax_sell_name_2 + ": " + detail.tax_sell_value_2 + "%" : ""}}</span>
													<span class="me-1">{{ detail.tax_sell_name_3 ? ", " + detail.tax_sell_name_3 + ": " + detail.tax_sell_value_3 + "%" : ""}}</span>
												</td>
											</tr>
										</tbody>
										<tfoot class="table-border-bottom-0" v-if="stateData.delivery_detail_list">
											<tr>
												<td class="text-end fw-bold">Total Amount (+Tax)</td>
												<td colspan="3" class="text-center fw-bold">VND {{ formatCurrency(calculateTotalAmount(listProucts)) }}</td>
											</tr>
										</tfoot>
									</table>
								</div>
							</div>

							<div class="row">
								<div class="col-md-12 mb-4">
									<label for="" class="form-label">Reference Quantity (choose one for Actual Quantity)</label>
									<div class="row">
										<div class="col-md-6 mb-2">
											<div class="form-check custom-option custom-option-basic">
												<label class="form-check-label lmd-label-left">
													<span class="custom-option-header">
														<span class="h6 mb-0">Input VAT</span>
														<div>
															<span class="mb-0 me-2 text-body-secondary">
																{{ formatCurrency(stateData.total_quantity_in) }}
															</span>
															<small>Pieces</small>
														</div>
													</span>
													<span class="custom-option-body">
														<small>Quantity in Delivery Voucher</small>
													</span>
												</label>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-check custom-option custom-option-basic">
												<label class="form-check-label lmd-label-left">
													<!-- <input name="customRadioTemp" class="form-check-input" type="radio" value="" id="customRadioTemp2"> -->
													<span class="custom-option-header">
														<span class="h6 mb-0">Output VAT</span>
														<div>
															<span class="mb-0 me-2 text-body-secondary">
																{{ formatCurrency(stateData.total_quantity_out) }}
															</span>
															<small>Pieces</small>
														</div>
													</span>
													<span class="custom-option-body">
														<small>Quantity in Delivery Voucher</small>
													</span>
												</label>
											</div>
										</div>
										<div class="col-md-12">
											<div class="form-check">
												<input class="form-check-input" 
													type="checkbox"
													id="confirmQuantity1"
													v-model="confirm_quantity"
												>
												<label class="form-check-label fw-bold" for="confirmQuantity1">
													I confirm the quantity of Input VAT and Output VAT are correct.
												</label>
											</div>
											<div class="error-msg" v-if="v$.confirm_quantity.$error"> 
												{{ v$.confirm_quantity.$errors[0].$message }}
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-10">
									<label class="form-label">Remark</label>
									<textarea 
										class="form-control" rows="2"
										v-model="stateData.remark"
									></textarea>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<form @submit.prevent="handleSave">
							<div class="col-sm-6">
								<button type="submit" class="btn btn-primary me-3" v-bind="{disabled: isDisabled}">Save Product Cost</button>
								<button type="button" 
									ref="closeModalBtn"
									class="btn btn-secondary" 
									data-bs-dismiss="modal" 
									aria-label="Close"
									@click="closeModal"
								>
									Close Modal
								</button>
							</div>
						</form>
					</div>
					<!-- / Cost Information -->

					<!-- Modal -->
					<div class="modal modal-transparent show fade" v-if="isLoading" id="basicModal" style="display: block;">
						<div class="modal-dialog modal-dialog-centered">
							<div class="modal-content">
								<div class="modal-body">
									<rise-loader :color="color" :size="size" style="text-align:center;"></rise-loader>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import RiseLoader from 'vue-spinner/src/RiseLoader.vue'
import flatPickr from 'vue-flatpickr-component';
import { configs } from '@/config/calendar.js';
import useValidate from '@vuelidate/core';
import { required, helpers, requiredIf } from '@vuelidate/validators'
import VueMultiselect from 'vue-multiselect';
import { PAYMENT_METHOD, CLOSING_TIME, COST_STATUS, CATEGORY_PRODUCT_COST } from "../../config/common.js"
import _ from 'lodash';
import moment from 'moment';
import { utilities } from "../../services/utilities.js";


export default {
	name: 'ProductCostDeliveryAddModal',
  components: {
		RiseLoader,
		flatPickr,
		VueMultiselect
  },
  props: {
		"delivery_voucher_id": {
			type: Number,
			required: false
		}
  },
  emits :{
		closeProductCostDeliveryAddModal: null
	},
	computed: {
    ...mapState({
      stateData: state => state.productCostDelivery.stateData,
			listProucts: state => state.productCostDelivery.stateData.delivery_detail_list
    }),
		categoryOptions() {
      return CATEGORY_PRODUCT_COST;
    },
		closingTimeOptions() {
			return CLOSING_TIME;
		},
		paymentMethodOptions() {
			return PAYMENT_METHOD;
		},
		costStatusOptions() {
			return COST_STATUS;
		},
		categoryProductCostOptions() {
			return CATEGORY_PRODUCT_COST;
		}
  },
	watch: {
		"partnerSelected" (newVal) {
      if (newVal == null) {
        this.stateData.partner_id = "";
        return;
      }
      this.stateData.partner_id = newVal.id;
			this.stateData.partner_code = newVal.partner_code;
    },
		"confirm_quantity" (newVal) {
			this.isDisabled = !newVal;
		},
		"stateData.partner_inv_date" (newVal) {
			if (!newVal || !this.partnerSelected) return;

			// Estimate the value of Payment Due Date
			let partner_inv_date = new Date(newVal);
			
			let estimated_date = this.getEstimatedPaymentDueDate(
				partner_inv_date, 
				this.partnerSelected.term, 
				this.partnerSelected.closing_time,
				this.partnerSelected.exact_date
			);
			
			if (!estimated_date) return;
			this.stateData.payment_due_date = estimated_date.format("YYYY-MM-DD");			
		},
		"stateData.payment_due_date" (newVal) {
			if (!newVal) {
				this.stateData.status = "";
				return;
			}
			let payment_date = this.$moment(newVal.toString());
			if (newVal && this.stateData.actual_payment_date) {
				let actual_date = this.$moment(this.stateData.actual_payment_date.toString());
				this.stateData.status = utilities.getCostStatusId(payment_date, actual_date);
			}
			if (newVal && !this.stateData.actual_payment_date){
				this.stateData.status = utilities.getCostStatusId(payment_date, "");
			}
		},
		"stateData.actual_payment_date" (newVal) {
			if (!newVal) {
				if (!this.stateData.payment_due_date) {
					this.stateData.status = "";
					return;
				}
				else {
					let payment_date = this.$moment(this.stateData.payment_due_date.toString());
					this.stateData.status = utilities.getCostStatusId(payment_date, "");
				}
			}
			if(newVal && this.stateData.payment_due_date) {
				let payment_date = this.$moment(this.stateData.payment_due_date.toString());
				let actual_date = this.$moment(newVal.toString());
				this.stateData.status = utilities.getCostStatusId(payment_date, actual_date);
			}
		},
		"delivery_voucher_id" (newVal) {
			this.isLoading = true;
			if (!newVal) return;
			this.$store.dispatch('productCostDelivery/getProductCostDetailForModalByDeliveryID', newVal).then(
				() => {
					this.isLoading = false;
					if (this.stateData.category_cost != null) {
						let cate_productCost = this.categoryOptions.find(option => 
							option.id == this.stateData.category_cost
						);
						this.stateData.category_cost = cate_productCost.id;	
					}

					this.total_quantity_in = this.stateData.total_quantity_in;
					this.total_quantity_out = this.stateData.total_quantity_out;

					if(this.stateData.cost_id) {
						this.confirm_quantity = true;
					}

					this.$store.dispatch('productCostDelivery/getListPartner').then(
						(response) => { 
							this.isLoading = false;
							this.list_partners = _.cloneDeep(response.listItems);
							if (this.stateData.partner_id) {
								this.partnerSelected = this.list_partners.filter(item => {
									return item.id == this.stateData.partner_id
								})[0];
							}
							else {
								this.partnerSelected = null;
							}
						},
						(error) => {
							this.isLoading = false;
							this.list_partners	= [];
							console.log(error);
							this.$swal.fire({
								icon: 'error',
								title: 'Error',
								text: 'Can not get the partner value !'
							});
						}
					);
				},
				(error) => {
					console.log(error);
					this.isLoading = false;
					this.stateData = {};
					this.$swal.fire({
						icon: 'error',
						title: 'Error',
						text: 'Sorry, can not get Product Cost information !'
					});
				}
			);
			
		}
	},
	data() {
		return {
			calendarConfig: configs,
			today: new Date(),
			v$: useValidate(),
			categoryCodeId: null,
			color: '#696cff',
      size: '20px',
      isLoading: false,
			partnerSelected: null,
			isError: false,
			isDisabled: true,
			list_partners: [],
			total_quantity_in: null,
			total_quantity_out: null,
			total_cost_amount_with_tax: null,
			confirm_quantity: false,
			// componentKey: 0,
			cleaveOptions: {
        cost_amount: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
					numeralDecimalScale: 2
        },
				cost_tax: {
					numeral: true,
					numeralThousandsGroupStyle: 'thousand',
					numeralDecimalScale: 1
				},
				cost_actual_amount: {
					numeral: true,
          numeralThousandsGroupStyle: 'thousand',
					numeralDecimalScale: 2
				}
			}
		}	
	},
	beforeCreate() {
	},
	created() {
		if(this.stateData.cost_id) {
			this.confirm_quantity = true;
		}
  },
	beforeMount() {
		if (this.list_partners.length > 0) return;
		else {
			this.$store.dispatch('productCostDelivery/getListPartner').then(
				(response) => { 
					this.list_partners = _.cloneDeep(response.listItems);
					if (this.stateData.partner_id) {
						this.partnerSelected = this.list_partners.filter(item => {
							return item.id == this.stateData.partner_id
						})[0];
					}
					else {
						this.partnerSelected = null;
					}
				},
				(error) => {
					this.list_partners	= [];
					console.log(error);
				}
			);
		}
	},
	mounted() {
	},
	methods: {
		handleSave() {
			this.v$.$validate();
			if (!this.v$.$error) {
				let request = {
          ...this.stateData
        }
        request = _.omit(request, ["delivery_detail_list"]);
				request["id"] = request.cost_id;
				request["supplier_inv_date"] = this.stateData.partner_inv_date;
				request["supplier_inv_no"] = this.stateData.partner_inv_no;
				request["cost_actual_amount"] = this.stateData.cost_actual_amount == "" ? null : this.stateData.cost_actual_amount;
				console.log("request: ", request);
				
				this.$store.dispatch(
					request.cost_id ? 'productCostDelivery/updateDeliveryProductCostModal' : 'productCostDelivery/createDeliveryProductCostModal', request
				).then(
					() => {
						this.isDisabled = false;
						this.$swal.fire(
							'Saved',
							`Product Cost information is ${request.cost_id ? 'updated' : 'saved'} sucessfully !`,
							'success'
						).then(() => this.$refs.closeModalBtn.click());
					},
					error => {
						console.log(error);
						this.isDisabled = false;
						this.$swal.fire({
							icon: 'error',
							title: 'Error',
							text: `Failed to ${request.cost_id ? 'saved' : 'updated'} Product Cost information !`
						});
					}
				);


			}
		},
		getClosingTime(close_time_id) {
      let query = this.closingTimeOptions.filter(item => item.id == close_time_id);
      return query[0].name
    },
    getPaymentName(val) {
      let query = this.paymentMethodOptions.filter((item) => {
        return item.value == val;
      });
      return query.length > 0 ? query[0].name_en : ""
    },
		getEstimatedPaymentDueDate (invoice_date, term, closing_time, exact_date=null) {
			let inv_date = moment(invoice_date);
			if (!this.isValidDate(inv_date)) return false;
			if (!term) return false;
			if (!closing_time) return false;

			switch (closing_time) {
				case 1:
				case 2:
				case 3:
				case 4:
				case 8:
				{	
					return inv_date.add(term, 'days');	
				}
				case 5:
				{
					return inv_date.subtract(3, 'days').add(term, 'days');
				}
				case 6:
				{
					let endOfMonth = inv_date.endOf('month');
					return endOfMonth.add(term, 'days');
				}
				case 7:
				{
					if (closing_time==7 && !exact_date) return false;
					let partner_inv_date = moment(inv_date).format("DD");
					let exact_date_value = parseInt(exact_date);
					if (parseInt(partner_inv_date) <= exact_date_value){
						return inv_date.add(exact_date_value + term, 'days');
					}
					else {
						return inv_date.add(exact_date_value + 30 + term, 'days');
					}
				}
			}
		},
		isValidDate(date) {
			return !isNaN(new Date(date).getTime());
		},
		formatCurrency(value) {
      return utilities.getFormatCurrency(value);
    },
		calculateAmount(productObject) {
			let result = 0;
      if (Object.keys(productObject).length > 0) {
        result = productObject.quantity_out * productObject.sell_price;
      }
      return result;
		},
		calculateTotalAmount(listProuctsArr) {
			let result = 0;
      if (listProuctsArr.length > 0) {
        listProuctsArr.forEach((item) => {
					result += item.sell_amount * this.stateData.sell_exchange_rates;
        });
      }
			this.total_cost_amount_with_tax = result;
      return result;
		},
		handleIconPasteCostAmount() {
			this.stateData.cost_actual_amount = this.formatCurrency(this.total_cost_amount_with_tax);
		},
		closeModal() {
			this.v$.$reset();
			this.confirm_quantity = false;
			this.isDisabled = true;
			this.$emit('closeProductCostDeliveryAddModal', true);

		}
	},
	validations() {
		return {
			confirm_quantity: {
				required: helpers.withMessage('CONFIRM QUANTITY must be checked', required)
			},
			stateData: {
				partner_inv_no: {
					required: helpers.withMessage('PARTNER INVOICE NO is required', required)
				},
				partner_inv_date: {
					required: helpers.withMessage('PARTNER INVOICE DATE is required', required)
				},
				actual_payment_date: {
					required: helpers.withMessage(
						'ACTUAL PAYMENT DATE is required if ACTUAL AMOUNT is inputed', 
						requiredIf (() => { return this.stateData.cost_actual_amount; })
					)
				},
				cost_actual_amount: {
					required: helpers.withMessage(
						'ACTUAL AMOUNT is required if ACTUAL PAYMENT DATE is inputed', 
						requiredIf (() => { return this.stateData.actual_payment_date; })
					)
				},
			}
		}
	}
}
</script>

<style>
	.modal-backdrop {
		z-index: 1050 !important;
	}
	.swal2-container {
		z-index: 2000 !important;
	}
	.span-float-right {
    float: right;
  }
	.lmd-label-left {
		padding: 1em;
    /* padding-left: 2.7em; */
		/* cursor: pointer; */
    width: 100%;
	}
	.table .lmd-light-color {
		--bs-table-bg: #d9dee2;
		vertical-align: middle;
	}
	@media (min-width: 992px) {
		#addProductCostDelivery .modal-lg {
			--bs-modal-width: 56rem;
		}
	}
</style>